import * as React from 'react'

import './search.scss'
import SearchIcon from '../../../images/search.png'

import { Format } from './helper'
import { IProps, IState, IKeywordsItem } from './interface'

class Search extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            data: {
                keywords: Format.keywordsToSearchItem(props.data.keywords, props.data.currentKeyword)
            },
            isSearch: false
        }
    }

    public componentWillReceiveProps = (nextProps: IProps) => {
        this.setState({
            data: {
                keywords: Format.keywordsToSearchItem(nextProps.data.keywords, nextProps.data.currentKeyword)
            }
        })
    }

    public render = () => {
        const { data, isSearch } = this.state
        return (
            !!data.keywords.length && <div>
                {!isSearch ?
                    <div className="activity-detail-search">
                        <ul className="keyword">
                            {data.keywords.map((item, index) => {
                                return <li
                                    className={`item${item.isSelected ? ' selected' : ''}`}
                                    key={index}
                                    onClick={this.clickKeyword.bind(this, item)}
                                >{item.name}</li>
                            })}
                        </ul>
                        <img className="icon" src={SearchIcon} onClick={this.changeSearchStatus} />
                    </div> :
                    <div className="activity-detail-search">
                        <form className="form" action="">
                            <input className="search-input" id="search" type="search" placeholder="搜索" autoComplete="off" onKeyPress={this.clickInputSearch} />
                        </form>
                        <div className="cancel" onClick={this.changeSearchStatus} >取消</div>
                    </div>}
            </div>
        )
    }

    private changeSearchStatus = () => {
        this.setState({
            isSearch: !this.state.isSearch
        }, () => {
            !this.state.isSearch && this.props.change('')
        })
    }

    private clickKeyword = (keyword: IKeywordsItem) => {
        if (!keyword.isSelected) {
            this.props.change(keyword.name)
        } else {
            this.props.change('')
        }
    }

    private clickInputSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.nativeEvent.keyCode === 13) {
            this.props.change(e.currentTarget.value)
            e.preventDefault()
        }
    }
}

export {
    Search
}


// WEBPACK FOOTER //
// ./src/components/activity_detail/search/search.tsx